import request, { http } from '@/utils/request'

// copy from crm
// 查询所有省份
export function addressGetAllProvince (val) {
    //
    return request({
        url: '/api/crm/open/address/getAllProvince', // 接口
        method: 'get', // 请求方式
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// 根据城市id查询区县
export function addressGetCountyByCityId (val) {
    return request({
        url: `/api/crm/open/address/getCountyByCityId/${val}`, // 接口
        method: 'get', // 请求方式
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// 根据省份code查询城市
export function addressGetCityByProvinceCode (val) {
    return request({
        url: `/api/crm/open/address/getCityByProvinceCode/${val}`, // 接口
        method: 'get', // 请求方式
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export const getAllProvince = () => http('get', '/api/crm/open/address/getAllProvince')
export const getCityByProvinceCode = (provId) => http('get', `/api/crm/open/address/getCityByProvinceCode/${provId}`)
export const getCountyByCityId = (cityId) => http('get', `/api/crm/open/address/getCountyByCityId/${cityId}`)
